import React from 'react'

import Link from 'next/link'
import styled from 'styled-components/macro'
import useTranslation from 'next-translate/useTranslation'

import { device, ColorsMap } from '@/utils/Theme'

import Icons from '../Icons'

export interface PathProps {
  pathLinks?: any[]
}

export const Path: React.FC<PathProps> = ({ pathLinks }) => {
  const { t } = useTranslation('common')

  return (
    <Wrapper id="path">
      <StyledPath>
        <Link href="/">{t('home')}</Link>
        {pathLinks.map((link) => {
          if (!link) {
            return null
          }
          return (
            <>
              <IconWrapper>
                <Icons.AngleRight color={ColorsMap.primary} />
              </IconWrapper>
              {link}
            </>
          )
        })}
      </StyledPath>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 2rem 8%;

  @media (max-width: ${device.mobileS}) {
    margin: 2rem 1rem;
  }
`

const StyledPath = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  * {
    max-width: 15rem;
    margin: 0.25rem 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
`
const IconWrapper = styled.div`
  margin: 0 0.5rem;
`

